import { faBuilding, faEdit } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction } from "react";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { CadastrarHorariosDisponiveisController } from "../../../../Controllers/VistoriaEntregaChaves/CompromissoDisponivel/CompromissoDisponivelController";
import { EditarHorariosDisponiveisService } from "../../../../Services/VistoriaEntregaDeChaves/CompromissoDisponivel/CompromissoDisponivelServices";
import { ICadastraEEditaHorarioDisponivelHorario } from "../../../../Interfaces/VistoriaEntregaChaves/CompromissoDisponivel/CompromissoDisponivelInterfaces";

interface ICadastrarEEditarHorariosProps {
    updateList: () => void;
    row?: ICadastraEEditaHorarioDisponivelHorario;
    setShow: Dispatch<SetStateAction<boolean>>;
}

export default function CadastraEEditaHorarios(
    props: ICadastrarEEditarHorariosProps
) {
    const FormMethods = useForm();
    const { execute: cadastrarHorario, loading: cadastrarHorarioLoading } =
        useAsyncCallback(CadastrarHorariosDisponiveisController);

    const { execute: editarHorario, loading: editarHorarioLoading } =
        useAsyncCallback(EditarHorariosDisponiveisService);

    function handleCadastrarOuEditarHorario(
        formData: ICadastraEEditaHorarioDisponivelHorario
    ) {
        if (!props.row) {
            cadastrarHorario({
                ...formData,
                ID_HORARIO: formData.DS_HORARIO,
            }).then(() => {
                props.updateList();
                props.setShow(false);
            });
        } else {
            editarHorario({
                ...formData,
                ID_COMPROMISSO_VISTORIA_DISPONIVEL_HORARIO:
                    props.row.ID_COMPROMISSO_VISTORIA_DISPONIVEL_HORARIO,
                ID_HORARIO: formData.DS_HORARIO,
            }).then(() => {
                props.updateList();
                props.setShow(false);
            });
        }
    }

    return (
        <FormProvider {...FormMethods}>
            <UnForm
                usingContext
                handleSubmit={handleCadastrarOuEditarHorario}
                className="row"
            >
                <div className="form-group col-12 ">
                    <UnForm.Input
                        type="time"
                        defaultValue={props.row?.DS_HORARIO}
                        name="DS_HORARIO"
                        label="Horário"
                        registerOptions={{
                            required: "Insira o nome do produto",
                        }}
                    />
                </div>
                <div className="col-12">
                    <UnForm.SubmitButton
                        outline
                        id="dados_form_submit_button"
                        color="success"
                        iconSize="lg"
                        loading={
                            cadastrarHorarioLoading || editarHorarioLoading
                        }
                        wrapperClassName="col-12 m-0 p-0"
                        loadingSize="sm"
                        className="d-none font-weight-bold col-12"
                        icon={props.row ? faEdit : faBuilding}
                    >
                        {props.row ? "Editar Horário" : "Cadastrar Horário"}
                    </UnForm.SubmitButton>
                </div>
            </UnForm>
        </FormProvider>
    );
}
